import { render, staticRenderFns } from "./ExBadgeHolderHeader.vue?vue&type=template&id=d287f82c"
import script from "./ExBadgeHolderHeader.vue?vue&type=script&lang=js"
export * from "./ExBadgeHolderHeader.vue?vue&type=script&lang=js"
import style0 from "./ExBadgeHolderHeader.vue?vue&type=style&index=0&id=d287f82c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports